var _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlagSelected = function SvgFlagSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 38,
    viewBox: "0 0 57 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56162 6.92875L5.72808 24.761C5.73518 25.5214 6.55596 25.9974 7.22615 25.638C21.5215 17.9729 37.3852 14.5806 46.8319 13.444C47.9163 13.3136 48.1129 11.7179 47.0745 11.3792C28.1733 5.21463 14.7673 5.48268 6.50329 5.92249C5.97004 5.95087 5.55664 6.39477 5.56162 6.92875Z",
    stroke: "#7EC2E4",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55272 6.36352L5.74386 26.8403C23.3355 16.9579 43.7688 13.7623 51.7864 13.3998C29.6057 5.27605 14.3602 5.86643 5.55272 6.36352Z",
    fill: "url(#flag_selected_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55272 5.58605L5.74386 26.0628C23.3355 16.1805 43.7688 12.9849 51.7864 12.6223C29.6057 4.49859 14.3602 5.08897 5.55272 5.58605Z",
    fill: "url(#flag_selected_paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16C39.48 16 35 20.48 35 26C35 31.52 39.48 36 45 36C50.52 36 55 31.52 55 26C55 20.48 50.52 16 45 16ZM42.29 30.29L38.7 26.7C38.31 26.31 38.31 25.68 38.7 25.29C39.09 24.9 39.72 24.9 40.11 25.29L43 28.17L49.88 21.29C50.27 20.9 50.9 20.9 51.29 21.29C51.68 21.68 51.68 22.31 51.29 22.7L43.7 30.29C43.32 30.68 42.68 30.68 42.29 30.29Z",
    fill: "#7EC2E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flag_selected_paint0_linear",
    x1: -5.52095,
    y1: 26.4136,
    x2: 70.4532,
    y2: 25.6364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flag_selected_paint1_linear",
    x1: -5.52095,
    y1: 25.6361,
    x2: 70.4532,
    y2: 24.8589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43AFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag_selected.6be11bad.svg";
export { ForwardRef as ReactComponent };